import { render, staticRenderFns } from "./StartDeletionDialog.vue?vue&type=template&id=5c937592&"
import script from "./StartDeletionDialog.vue?vue&type=script&lang=ts&"
export * from "./StartDeletionDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports